<template>
  <div class="cfa-root">
    <c-f-a-nav
      :alert="alertString"
      :refresh="silentRefresh"
      :css_class="userData != null ? '' : 'position-relative'"
    >
      <template v-slot:title>
        <div class="w-100 pt-5 text-start mb-3">
          <h1 class="cfa-section-title">{{ $t("param") }}</h1>
        </div>
        <br />
      </template>
      <template v-slot:content>
        <div v-if="userData != null" class="cfa-page">
          <!-- banner1 -->
          <div class="cfa-block p-4">
            <div class="d-flex align-items-center justify-content-between">
              <h1 class="cfa-section-title mb-0">{{ $t("my_information") }}</h1>
              <div class="d-flex">
                <a
                  style="border-color: #d2dcf7; border-width: 2px"
                  class="btn align-self-center btn-secondary btn-discret d-none d-md-block"
                >
                  <i
                    class="fa fa-user-circle margin-right-10"
                    aria-hidden="true"
                  ></i
                  >&nbsp;{{ $t('settings.account') }}
                  {{
                    userData.type_account.toString().toUpperCase() ==
                    "ORGANISATION_USER"
                      ? $t('settings.guest_organization')
                      : userData.type_account.toString().toUpperCase()
                  }}
                </a>
                <!-- Replace the current avatar button with dropdown -->
                <!-- <div class="dropdown">
                  <button class="ps-2 ms-2 btn align-self-center cfa-btn-primary dropdown-toggle" type="button" id="avatarDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    <i v-if="!uploadPending" class="fa fa-image margin-right-10 d-none d-md-inline white-color" aria-hidden="true">&nbsp;</i>
                    <span v-if="!uploadPending" class="d-none d-md-inline">{{ $t('update_avatar') }}</span>
                    <span v-if="!uploadPending" class="d-md-none d-inline">Avatar</span>
                    <div v-if="uploadPending" class="" style="width: 11em;">
                      <img width="20" src="@/assets/img/gif/load2.gif" alt="loader"/>
                    </div>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="avatarDropdown">
                    <li><a class="dropdown-item" href="#" @click="openFileSelector">{{ $t('upload_new_image') || 'Upload new image' }}</a></li>
                    <li><a class="dropdown-item" href="#" @click="removeProfilePicture">{{ $t('remove_profile_picture') || 'Remove profile picture' }}</a></li>
                  </ul>
                </div> -->

                <div class="avatar-container">
                  <div class="dropdown">
                    <button
                      class="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i
                        v-if="!uploadPending"
                        class="fa fa-image margin-right-10 d-none d-md-inline white-color"
                        aria-hidden="true"
                        >&nbsp;</i
                      >
                      <span v-if="!uploadPending" class="d-none d-md-inline">{{
                        $t("update_avatar")
                      }}</span>
                      <span v-if="!uploadPending" class="d-md-none d-inline"
                        >Avatar</span
                      >
                      <div v-if="uploadPending" class="" style="width: 11em">
                        <img
                          width="20"
                          src="@/assets/img/gif/load2.gif"
                          alt="loader"
                        />
                      </div>
                    </button>
                    <ul
                      class="dropdown-menu avatar-dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <li class="dropdown-header">
                        {{ $t('settings.choose_predefined_avatar') }}
                      </li>
                      <li class="avatar-grid-container">
                        <div class="avatar-grid">
                          <div
                            v-for="avatar in avatars"
                            :key="avatar"
                            class="avatar-option"
                            @click="selectAvatar(avatar)"
                            :class="{ selected: userData.image_url === avatar }"
                          >
                            <img
                              :src="avatar"
                              alt="Avatar"
                              class="avatar-preview"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <hr class="dropdown-divider" />
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="openFileSelector"
                        >
                          <i class="fa fa-upload me-2"></i>{{ $t('settings.upload_new_image') }}
                        </a>
                      </li>
                      <li v-if="userData.image_url">
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="removeProfilePicture"
                        >
                          <i class="fa fa-trash me-2"></i>{{ $t('settings.remove_profile_picture') }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <input
                    ref="fileSelector"
                    type="file"
                    accept="image/*"
                    @change="uploadImage"
                    style="display: none"
                  />
                </div>
                <input
                  type="file"
                  ref="fileSelector"
                  @change="uploadImage"
                  style="display: none"
                />
              </div>
            </div>

            <section class="text-center py-4" style="border-radius: 0.5em">
              <div>
                <img
                  class="bg-white p-1"
                  width="150"
                  height="150"
                  style="border-radius: 100%"
                  :src="
                    userData.image_url != null
                      ? userData.image_url
                      : defaultImage
                  "
                  alt="logo company"
                />
              </div>
            </section>

            <section class="mt-4">
              <div class="row">
                <div class="col-12 col-md-4 pl-0">
                  <div class="form-group">
                    <label class="control-label" for="inputFirstname">{{
                      $t("first_name")
                    }}</label>
                    <input
                      id="inputFirstname"
                      class="form-control"
                      name="inputFirstname"
                      type="text"
                      v-model="firstname"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-4 pl-0">
                  <div class="form-group">
                    <label class="control-label" for="inputLastname">{{
                      $t("last_name")
                    }}</label>
                    <input
                      id="inputLastname"
                      class="form-control"
                      name="inputLastname"
                      type="text"
                      v-model="lastname"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-4 pl-0 pr-0">
                  <div class="form-group">
                    <label class="control-label" for="inputEmail">Email</label>
                    <input
                      id="inputEmail"
                      class="form-control"
                      name="inputEmail"
                      type="email"
                      :value="userData.email"
                      disabled=""
                    />
                  </div>
                </div>
              </div>
            </section>
            <section class="mt-4">
              <div class="row">
                <!-- <div class="col-12 col-md-4 pl-0">
                  <div class="form-group">
                    <label class="control-label" for="inputFirstname">{{
                      $t("personal_phone")
                    }}</label>
                    <input-phone
                      @updateNumber="(number) => (phonePersonal = number)"
                      :init-value="
                        phonePersonal
                          ? phonePersonal.startsWith('+')
                            ? phonePersonal
                            : `+${phonePersonal}`
                          : ''
                      "
                    />
                  </div>
                </div> -->
                <div class="col-12 col-md-4 pl-0">
                  <div class="form-group">
                    <label class="control-label" for="inputLastname">{{
                      $t("professional_phone")
                    }}</label>
                    <input-phone
                      @updateNumber="(number) => (phoneProfessional = number)"
                      :init-value="
                        phoneProfessional
                          ? phoneProfessional.startsWith('+')
                            ? phoneProfessional
                            : `+${phoneProfessional}`
                          : ''
                      "
                    />
                  </div>
                </div>
                <div class="col-12 col-md-4 pl-0 pr-0">
                  <div class="form-group">
                    <label class="control-label" for="inputEmail"
                      >{{ $t('settings.company') }}</label
                    >
                    <input
                      id="inputEmail"
                      class="form-control"
                      name="inputEmail"
                      type="email"
                      :value="userData.organisation_detail?.name"
                      disabled=""
                    />
                  </div>
                </div>
              </div>
            </section>
            <div class="mt-4 d-flex justify-content-between align-items-center">
              <div class="text-left">
                {{ $t("valid_information") }}
              </div>
              <button
                @click="updateUserProfil"
                id="validateButton-pass"
                class="btn btn-round cfa-btn-primary"
                type="submit"
              >
                {{ $t("continue") }}
              </button>
            </div>
          </div>
          <br />

          <!-- banner3
          <div class="cfa-block p-4 mt-4">
            <h1 class="cfa-section-title">MON COMPTE</h1><br>
            <section class="padding-top-20 pb-0">
              <form id="general" class="" role="tabpanel">
                <div id="general" class="tab-pane active" role="tabpanel">
                  <div class="col-sm-6 col-md-12 pl-0">
                    <div class="form-group ">
                      <label class="control-label" for="inputFirstname">Type de compte</label>
                      <input id="inputFirstname" class="form-control" name="inputFirstname" type="text" :value="userData.type_account.charAt(0).toUpperCase() + userData.type_account.slice(1)" disabled>
                    </div>
                  </div>
                </div>
              </form>
            </section>
          </div> -->

          <!-- banner4 -->
          <div class="cfa-block p-4">
            <h4>{{ $t("changing_password") }}</h4>
            <br />
            <div>
              <div class="tab-pane">
                <div class="col-12 pl-0">
                  <div class="form-group">
                    <label class="control-label" for="inputPassnew">{{
                      $t("old_password")
                    }}</label>
                    <div class="input-group">
                      <input
                        v-model="oldPassword"
                        autocomplete="new-password"
                        class="w-full px-4 py-2 input input-bordered ui-input"
                        name="inputPassnew"
                        :type="toggle.oldPassword ? 'text' : 'password'"
                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$"
                        required=""
                      />
                      <span class="absolute right-2 top-3 cursor-pointer" @click="toggle.oldPassword = false" v-if="toggle.oldPassword"><i class="fa fa-eye"></i></span>
                      <span class="absolute right-2 top-3 cursor-pointer" @click="toggle.oldPassword = true" v-if="!toggle.oldPassword"><i class="fa fa-eye-slash"></i></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="inputPassnew">{{
                      $t("new_password")
                    }}</label>
                    <div class="input-group">
                      <input
                        v-model="newPassword"
                        autocomplete="new-password"
                        class="w-full px-4 py-2 input input-bordered ui-input"
                        name="inputPassnewOne"
                        :type="toggle.newPassword ? 'text' : 'password'"
                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$"
                        required=""
                      />
                      <span class="absolute right-2 top-3 cursor-pointer" @click="toggle.newPassword = false" v-if="toggle.newPassword"><i class="fa fa-eye"></i></span>
                      <span class="absolute right-2 top-3 cursor-pointer" @click="toggle.newPassword = true" v-if="!toggle.newPassword"><i class="fa fa-eye-slash"></i></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="inputPassnew"
                      >{{ $t('settings.confirm_new_password') }}</label
                    >
                    <div class="input-group">
                      <input
                        v-model="confirmNewPassword"
                        autocomplete="new-password"
                        class="w-full px-4 py-2 input input-bordered ui-input"
                        name="inputPassnewOne"
                        :type="toggle.confirmPassword ? 'text' : 'password'"
                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$"
                        required=""
                      />
                      <span class="absolute right-2 top-3 cursor-pointer" @click="toggle.confirmPassword = false" v-if="toggle.confirmPassword"><i class="fa fa-eye"></i></span>
                      <span class="absolute right-2 top-3 cursor-pointer" @click="toggle.confirmPassword = true" v-if="!toggle.confirmPassword"><i class="fa fa-eye-slash"></i></span>
                    </div>
                  </div>
                  <br />
                  <div class="d-flex justify-content-end align-items-center">
                    <!-- <div class="text-left">
                      {{ $t('enter_password') }}
                    </div> -->
                    <button
                      @click="tryChangePassword"
                      class="btn btn-round cfa-btn-primary"
                      type="submit"
                    >
                      {{ $t('settings.validate') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 2FA Setup Section -->
          <div class="cfa-block p-4 mt-4">
            <!-- <h4>Configuration de l'authentification à deux facteurs (2FA)</h4><br>
            <div>
              <div class="tab-pane">
                <div class="col-12 pl-0">
                  <p>L'authentification à deux facteurs ajoute une couche de sécurité supplémentaire à votre compte.</p>
                  
                  <div class="form-group">
                    <label class="control-label">Choisissez votre méthode d'authentification à deux facteurs</label>
                    <div class="d-flex flex-column flex-md-row mt-3">
                      <button @click="setupTwoFA('email')" class="btn me-md-3 mb-3 mb-md-0 btn-round cfa-btn-primary " :disabled="twoFAPending" style="position: relative">
                        <span>
                          <i class="fa fa-envelope me-2 white-color"></i> Par email
                        </span>
                            <div class="notification-dot" style="position:absolute; right: -2px; top:-2px" v-if="userData?.otp_method == 'email'"></div>

                      </button>
                      <button @click="setupTwoFA('app')" class="btn btn-outline-primary btn-round cfa-btn-primary" :disabled="twoFAPending" style="position: relative">
                        <span>
                        <i class="fa fa-mobile-alt me-2 white-color"></i> Par application d'authentification
                        </span>
                        <div class="notification-dot" style="position:absolute; right: -2px; top:-2px" v-if="userData?.otp_method == 'app'"></div>
                      </button>
                    </div>
                  </div>
                  
                  <div v-if="twoFAPending" class="text-center my-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Chargement...</span>
                    </div>
                    <p class="mt-2">Configuration en cours...</p>
                  </div>
                  
                  <div v-if="showQRCode && qrCodeData" class="my-4">
                    <div class="alert alert-info">
                      <h5 class="alert-heading">Scannez ce code QR avec votre application d'authentification</h5>
                      <p>Utilisez une application comme Google Authenticator, Authy ou Microsoft Authenticator pour scanner ce code.</p>
                      
                      <div class="text-center my-3">
                        <qrcode-vue :value="qrCodeData" :size="200" level="H" class="d-inline-block"></qrcode-vue>
                        <p class="mt-2 mb-0">Code: {{ otpCode }}</p>
                        <p class="text-muted small">Vous pouvez également saisir ce code manuellement dans votre application</p>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="twoFAMethod === 'email'" class="alert alert-success my-4">
                    <h5 class="alert-heading">Configuration réussie!</h5>
                    <p>L'authentification à deux facteurs par email a été activée. Vous recevrez un code de vérification par email lors de votre prochaine connexion.</p>
                  </div>
                </div>
              </div>
            </div> -->
            <h4 class="mb-4">{{ $t('settings.mfa_title') }}</h4>

            <div class="">
              <!-- Application d'authentification -->
              <div class="mb-4">
                <div class="mfa-section">
                  <h5 class="mfa-title">
                    <i class="fa fa-mobile-alt me-2"></i>
                    {{ $t('settings.mfa_app_title') }}
                  </h5>
                  <p class="mfa-description">
                    {{ $t('settings.mfa_app_description') }}
                  </p>
                  <button
                    @click="setupTwoFA('app')"
                    class="btn mfa-action-btn"
                    :class="
                      isApp2FAActive ? 'mfa-btn-danger' : 'mfa-btn-primary'
                    "
                    :disabled="twoFAPending.app"
                  >
                    <span v-if="!twoFAPending.app">
                      {{
                        isApp2FAActive
                          ? $t('settings.mfa_remove_config')
                          : $t('settings.mfa_configure')
                      }}
                    </span>
                    <span v-else>
                      <span
                        class="spinner-border spinner-border-sm me-2"
                      ></span>
                      {{ $t('settings.mfa_configuring') }}
                    </span>
                  </button>
                </div>
              </div>

              <!-- Authentification par e-mail -->
              <div class="mb-4">
                <div class="mfa-section">
                  <h5 class="mfa-title">
                    <i class="fa fa-envelope me-2"></i>
                    {{ $t('settings.mfa_email_title') }}
                  </h5>
                  <p class="mfa-description">
                    {{ $t('settings.mfa_email_description') }}
                  </p>
                  <button
                    @click="setupTwoFA('email')"
                    class="btn mfa-action-btn"
                    :class="
                      isEmail2FAActive ? 'mfa-btn-danger' : 'mfa-btn-primary'
                    "
                    :disabled="twoFAPending.email"
                  >
                    <span v-if="!twoFAPending.email">
                      {{ isEmail2FAActive ? $t('settings.mfa_disable') : $t('settings.mfa_enable') }}
                    </span>
                    <span v-else>
                      <span
                        class="spinner-border spinner-border-sm me-2"
                      ></span>
                      {{ $t('settings.mfa_configuring') }}
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-group">
              <!-- <label class="control-label">Choisissez votre méthode d'authentification à deux facteurs</label> -->
              <div class="d-flex flex-column flex-md-row mt-3">
                <!-- <p></p> -->
                <!-- <button @click="setupTwoFA('email')" class="btn me-md-3 mb-3 mb-md-0 btn-round cfa-btn-primary " :disabled="twoFAPending" style="position: relative">
                        <span>
                          <i class="fa fa-envelope me-2 white-color"></i> Par email
                        </span>
                            <div class="notification-dot" style="position:absolute; right: -2px; top:-2px" v-if="userData?.otp_method == 'email'"></div>

                      </button> -->
                <!-- <button @click="setupTwoFA('app')" class="btn btn-outline-primary btn-round cfa-btn-primary" :disabled="twoFAPending" style="position: relative">
                        <span>
                        <i class="fa fa-mobile-alt me-2 white-color"></i> Par application d'authentification
                        </span>
                        <div class="notification-dot" style="position:absolute; right: -2px; top:-2px" v-if="userData?.otp_method == 'app'"></div>
                      </button> -->
              </div>
            </div>
            <div></div>
          </div>

          <!-- banner5 -->
          <div class="cfa-block p-4 mt-4">
            <h4>{{ $t("language_settings") }}</h4>
            <br />
            <div>
              <div class="tab-pane">
                <div class="language-dropdown-container">
                  <div
                    class="language-dropdown"
                    @click="toggleLanguageDropdown"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between border p-3 rounded-2 cursor-pointer"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          width="25"
                          class="mr-3"
                          :src="getCurrentLanguageFlag()"
                          alt=""
                        />
                        <span>{{ getCurrentLanguageName() }}</span>
                      </div>
                      <i
                        class="fa-solid fa-chevron-down"
                        :class="{ 'rotate-180': showLanguageDropdown }"
                      ></i>
                    </div>
                  </div>

                  <div
                    v-if="showLanguageDropdown"
                    class="language-options mt-2 border rounded-2 overflow-hidden"
                  >
                    <div
                      class="language-option d-flex align-items-center p-3 cursor-pointer hover-bg"
                      @click="selectLanguage('fr')"
                      :class="{ selected: $i18n.locale === 'fr' }"
                    >
                      <img
                        width="25"
                        class="mr-3"
                        src="../../assets/img/svg/lang/fr.svg"
                        alt="Français"
                      />
                      <span>Français</span>
                    </div>
                    <div
                      class="language-option d-flex align-items-center p-3 cursor-pointer hover-bg"
                      @click="selectLanguage('en')"
                      :class="{ selected: $i18n.locale === 'en' }"
                    >
                      <img
                        width="25"
                        class="mr-3"
                        src="../../assets/img/svg/lang/en.svg"
                        alt="English"
                      />
                      <span>English</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="cfa-block p-4 mt-4">
            <h4>PARAMETRES DE LANGUE</h4><br>
            <div>
              <div class="tab-pane">
                <form class="langForm">
                  <input checked class="radioLang" type="radio" id="contactChoice1" name="lang" value="fr">
                  <label for="contactChoice1" style="position: relative; bottom: 1.1em; margin-right: 1em; margin-left: .5em; cursor: pointer;">
                    <img width="25" class="mr-4" src="../../assets/img/svg/lang/fr.svg" alt="">
                  </label>

                  <input class="radioLang" type="radio" id="contactChoice2" name="lang" value="en" disabled>
                  <label for="contactChoice2" style="no-pointer-events: none; position: relative; bottom: 1.1em; margin-right: 1em; margin-left: .5em; cursor: pointer;">
                    <img width="25" class="mr-4" src="../../assets/img/svg/lang/en.svg" alt="">
                  </label>
                </form>
              </div>
            </div>
          </div> -->

          <!-- banner6 -->
        </div>
        <pre-loader v-else></pre-loader>
      </template>
    </c-f-a-nav>
    <c-f-a-footer></c-f-a-footer>

    <!-- Modal de vérification 2FA -->
    <scalable-modal
      uid="verificationModal"
      :open="show2FAVerificationForm"
      @close="cancelVerification"
      disable-control
      style="max-width: 500px"
    >
      <template v-slot:content>
        <div class="text-center">
          <div class="mb-4">
            <div class="mfa-modal-icon">
              <i class="fa fa-shield-alt fa-3x"></i>
            </div>
            <h3 class="mt-3">{{ $t('settings.verification_required') }}</h3>
            <p class="text-muted">
              {{ $t('settings.verification_description') }}
            </p>
          </div>

          <div class="form-group text-left">
            <input
              type="text"
              v-model="verificationCode"
              class="form-control text-center text-2xl tracking-widest"
              :class="{ 'is-invalid': errors.verificationCode }"
              :placeholder="$t('settings.enter_code')"
              maxlength="6"
            />
            <div
              v-if="errors.verificationCode"
              class="invalid-feedback text-left"
            >
              {{ errors.verificationCode }}
            </div>
          </div>

          <div class="mt-4">
            <button
              class="btn mfa-btn-primary px-4 py-2 w-100"
              @click="verify2FACode"
            >
              {{ $t('settings.verify') }}
            </button>
          </div>

          <div class="mt-3 text-center">
            <p class="text-muted">
              {{ $t('settings.code_not_received') }}
              <a
                href="#"
                @click.prevent="resendVerificationCode"
                class="text-primary"
              >
                {{ $t('settings.resend_code') }}
              </a>
            </p>
          </div>
        </div>
      </template>
    </scalable-modal>

    <!-- Modal QR Code pour App -->
    <scalable-modal
      uid="qrCodeModal"
      :open="showAppQRModal"
      @close="showAppQRModal = false"
      disable-control
      disable-quit
      style="max-width: 600px"
    >
      <template v-slot:content>
        <div class="text-center">
          <div class="mb-4">
            <div class="mfa-modal-icon">
              <i class="fa fa-mobile-alt fa-3x"></i>
            </div>
            <h3 class="mt-3 mb-2">
              {{ $t('settings.qr_code_title') }}
            </h3>
            <p class="text-muted">
              {{ $t('settings.qr_code_description') }}
            </p>
          </div>

          <div class="bg-light p-4 rounded mb-3">
            <qrcode-vue
              :value="qrCodeData"
              :size="200"
              level="H"
              class="d-inline-block"
            ></qrcode-vue>
          </div>

          <div class="alert alert-info border-0 text-left">
            <p class="mb-2"><strong>{{ $t('settings.secret_code') }}</strong></p>
            <code class="bg-white p-2 rounded d-block">{{ otpCode }}</code>
            <p class="text-muted small mt-2 mb-0">
              {{ $t('settings.secret_code_manual') }}
            </p>
          </div>

          <button
            class="btn mfa-btn-primary px-4 py-2"
            @click="showAppQRModal = false"
          >
            <i class="fa fa-check me-2"></i>{{ $t('settings.done') }}
          </button>
        </div>
      </template>
    </scalable-modal>

    <!-- Modal Succès Email -->
    <scalable-modal
      uid="emailSuccessModal"
      :open="showEmailSuccessModal"
      @close="showEmailSuccessModal = false"
      disable-control
      disable-quit
      style="max-width: 500px"
    >
      <template v-slot:content>
        <div class="text-center">
          <div class="mfa-modal-icon success">
            <i class="fa fa-check-circle fa-3x"></i>
          </div>
          <h3 class="mt-3 mb-2">{{ $t('settings.config_success_title') }}</h3>
          <p class="text-muted mb-4">
            {{ $t('settings.email_config_success') }}
          </p>
          <button
            class="btn mfa-btn-primary px-4 py-2"
            @click="showEmailSuccessModal = false"
          >
            <i class="fa fa-check me-2"></i>{{ $t('settings.understood') }}
          </button>
        </div>
      </template>
    </scalable-modal>

    <!-- Modal Désactivation Succès -->
    <scalable-modal
      uid="disableSuccessModal"
      :open="showDisableSuccessModal"
      @close="() => { showDisableSuccessModal = false; disabledMethod = null; }"
      disable-control
      disable-quit
      style="max-width: 500px"
    >
      <template v-slot:content>
        <div class="text-center">
          <div class="mfa-modal-icon">
            <i class="fa fa-info-circle fa-3x"></i>
          </div>
          <h3 class="mt-3 mb-2">{{ $t('settings.method_disabled_title') }}</h3>
          <p class="text-muted mb-4">
            {{ disabledMethod === "app" ? $t('settings.app_auth_disabled') : $t('settings.email_auth_disabled') }}
          </p>
          <button
            class="btn mfa-btn-primary px-4 py-2"
            @click="showDisableSuccessModal = false"
          >
            <i class="fa fa-check me-2"></i>{{ $t('settings.understood') }}
          </button>
        </div>
      </template>
    </scalable-modal>
  </div>
</template>

<script>
import CFAFooter from "@/components/nav/CFAFooter.vue";
import CFANav from "@/components/nav/CFANav.vue";
// eslint-disable-next-line
import { getAPI, guestAPI } from "@/axios-api.js";
import PreLoader from "@/components/shared/PreLoader.vue";
import InputPhone from "@/components/shared/input/InputPhone.vue";
import QrcodeVue from "qrcode.vue";
import ScalableModal from "@/components/shared/modal/ScalableModal.vue";

export default {
  name: "ParameterView",
  components: {
    CFAFooter,
    CFANav,
    PreLoader,
    InputPhone,
    QrcodeVue,
    ScalableModal,
  },
  data() {
    return {
      userData: null,
      alertString: null,
      defaultImage: " /images/avatar-default.png",
      firstname: "...",
      lastname: "...",
      phonePersonal: "...",
      phoneProfessional: "...",
      toggle: {
        oldPassword: false,
        newPassword: false,
        confirmPassword: false,
      },
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      silentRefresh: null,
      uploadPending: false,
      role: "",
      primary: "red",
      secondary: "yellow",
      // Add 2FA related data properties
      twoFAMethod: null,
      show2FAVerificationForm: false,
      verificationCode: "",
      twoFAPending: {
        app: false,
        email: false,
      },
      qrCodeData: null,
      otpCode: null,
      errors: {
        verificationCode: null,
      }, // Modal properties
      showAppQRModal: false,
      showEmailSuccessModal: false,
      showDisableSuccessModal: false,
      disabledMethod: null,

      // Language dropdown properties
      showLanguageDropdown: false,
      avatars: [
        "/images/avatars/homme.png",
        "/images/avatars/femme.png",
        "/images/avatars/homme-1.png",
        "/images/avatars/femme-1.png",
        "/images/avatars/homme-2.png",
        "/images/avatars/femme-2.png",
        "/images/avatars/homme-3.png",
        "/images/avatars/joueur.png",
        "/images/avatars/fille.png",
      ],
    };
  },
  computed: {
    isApp2FAActive() {
      return this.userData?.otp_methods?.includes("app") || false;
    },
    isEmail2FAActive() {
      return this.userData?.otp_methods?.includes("email") || false;
    },
  },
  methods: {
    changeLanguage(obj) {
      localStorage.setItem("language", obj.target.value);
    },
    changeLang(event) {
      console.log(event);
      localStorage.setItem("language", event.target.value);
    },
    // Language dropdown methods
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    selectLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
      this.showLanguageDropdown = false;
    },
    getCurrentLanguageFlag() {
      return this.$i18n.locale === "fr"
        ? require("@/assets/img/svg/lang/fr.svg")
        : require("@/assets/img/svg/lang/en.svg");
    },
    getCurrentLanguageName() {
      return this.$i18n.locale === "fr" ? "Français" : "English";
    },
    retrieveUserData() {
      getAPI
        .get("accounts/users/me")
        .then((response) => {
          if (response.status == 200) {
            this.userData = response.data.data;
            this.firstname = this.userData.firstname;
            this.lastname = this.userData.lastname;
            this.role = this.userData.role;
            this.phonePersonal = this.userData.phone;
            this.phoneProfessional = this.userData.phone;
          } else {
            //this.alertString = "Oups ! something went wrong.|alert-no|5000::"+Date.now()
          }
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|5000::`+Date.now()
          } else if (error.request) {
            //this.alertString = "The request was made but no response was received. Please check your network.|alert-no|8000::"+Date.now()
          } else {
            //this.alertString = "Oups ! something went wrong.|alert-no|5000::"+Date.now()
          }
        });
    },
    tryChangePassword() {
      if (
        this.oldPassword == "" ||
        this.newPassword == "" ||
        this.confirmNewPassword == ""
      ) {
        this.alertString =
          `Les champs sont requis |alert-no|6000::` + Date.now();
        return;
      }
      if (this.newPassword != this.confirmNewPassword) {
        this.alertString =
          `Les mots de passe doivent etre identique |alert-no|6000::` +
          Date.now();
        return;
      }
      if (this.oldPassword.length > 2) {
        /*guestAPI.post('accounts/login',
          {
            email: this.userData.email,
            password: this.oldPassword,
          })
        .then(response => {
            if(response.status == 200) {
              // send password forget mail
              guestAPI.post('accounts/forgot-password', {
                email: this.userData.email,
              })
              .then(response => {
                if(response.status == 200) {
                  //this.alertString = "Veuillez vérifier votre adresse e-mail pour changer le mot de passe.|alert-yes|6000::"+Date.now()
                }
                else {
                  //this.alertString = "Oups ! something went wrong.|alert-no|5000::"+Date.now()
                }
              })
              .catch(() => {
                //this.alertString = "Oups ! something went wrong.|alert-no|5000::"+Date.now()
              })
              // -------------------------
            }
            else {
              //this.alertString = `Votre mot de passe erroné. Etes-vous ${localStorage.firstname} ${localStorage.lastname}?|alert-no|6000::`+Date.now()
            }
          })
        .catch(() => {
            //this.alertString = `Votre mot de passe erroné. Etes-vous ${localStorage.firstname} ${localStorage.lastname}?|alert-no|6000::`+Date.now()
        })*/
        getAPI
          .post("accounts/change-password", {
            current_password: this.oldPassword,
            new_password: this.newPassword,
          })
          .then((res) => {
            console.log(res);
            if (res.status == 200) {
              this.alertString =
                "Mot de passe mise à jour .|alert-yes|6000::" + Date.now();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.status == 400) {
              this.alertString =
                `Mot de passe errone |alert-no|6000::` + Date.now();
            } else {
              this.alertString =
                `Une erreur s'est produite |alert-no|6000::` + Date.now();
            }
          });
      } else {
        //this.alertString = "Veuillez remplir correctement le champ.|alert-no|5000::"+Date.now()
      }
    },
    openFileSelector() {
      this.$refs.fileSelector.click();
    },
    async uploadImage() {
      const file = this.$refs.fileSelector.files[0];
      const formData = new FormData();
      formData.append("image_url", file);

      this.uploadPending = true;
      getAPI
        .put(`accounts/users/upload-profile/${localStorage.user}/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((payload) => {
          this.userData.image_url = payload.data.data.image_url;
          //this.alertString = "Profil mis a jours avec succès.|alert-yes|5000::"+Date.now()
          this.silentRefresh = Date.now();
          this.uploadPending = false;
        })
        .catch((err) => {
          //this.alertString = "Fichier trop large.|alert-no|5000::"+Date.now()
          this.uploadPending = false;
          console.log(err);
        });
    },
    updateUserProfil() {
      if (this.firstname != "" && this.lastname != "") {
        getAPI
          .put(`accounts/users/${localStorage.user}/`, {
            firstname: this.firstname,
            lastname: this.lastname,
            phone: this.phoneProfessional,
            //role: this.role
          })
          .then((response) => {
            if (response.status == 200) {
              localStorage.setItem("firstname", this.firstname);
              localStorage.setItem("lastname", this.lastname);
              localStorage.setItem("phone", this.phoneProfessional);
              this.alertString =
                "Profil mis à jour avec succès|alert-yes|5000::" + Date.now();
              this.silentRefresh = Date.now();
              // this.$router.go(0);
            } else {
              this.alertString =
                "Quelque chose s'est mal passé.|alert-no|5000::" + Date.now();
            }
          })
          .catch(() => {
            this.alertString =
              "Quelque chose s'est mal passé.|alert-no|5000::" + Date.now();
          });
      } else {
        this.alertString =
          "Veuillez remplir les champs correctement.|alert-no|5000::" +
          Date.now();
      }
    },
    hexToRgb(hex) {
      // Remove '#' character if present
      hex = hex.replace("#", "");
      // Convert hex to RGB
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return { r, g, b };
    },
    retrieveOrg() {
      getAPI
        .get(`organisations/${localStorage.organisation}/`)
        .then((response) => {
          if (response.status == 200) {
            this.organisationData = response.data;
            this.primary = this.organisationData.primary_color;
            this.secondary = this.organisationData.secondary_color;
          } else {
            //this.alertString = "Oups ! something went wrong.|alert-no|5000::"+Date.now()
          }
        })
        .catch((error) => {
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|5000::`+Date.now()
          } else if (error.request) {
            //this.alertString = "The request was made but no response was received. Please check your network.|alert-no|8000::"+Date.now()
          } else {
            //this.alertString = "Oups ! something went wrong.|alert-no|5000::"+Date.now()
          }
        });
    },
    saveColor() {
      const payload = {
        primary_color: this.primary_color,
        secondary_color: this.secondary_color,
        tertiary_color: this.tertiary_color,
      };
      getAPI
        .put(
          `organisations/change_color/${localStorage.organisation}/`,
          payload
        )
        .then((response) => {
          if (response.status === 200) {
            console.log("response", response);
            if (response.data.data) {
              // localStorage.setItem('primaryColor', this.primary);
              // localStorage.setItem('secondaryColor', this.secondary);
              localStorage.setItem(
                "tertiaryColor",
                response.data.data.tertiary_color
              );
            }
            this.alertString =
              "Couleur changée avec succès |alert-yes|5000::" + Date.now();
          } else {
            this.alertString =
              "Oups ! something went wrong.|alert-no|5000::" + Date.now();
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log("respose", error.response);
            this.alertString =
              `Upgrade your plan for change color|alert-no|5000::` + Date.now();
          } else if (error.request) {
            this.alertString =
              "The request was made but no response was received. Please check your network.|alert-no|8000::" +
              Date.now();
          } else {
            this.alertString =
              "Oups ! something went wrong.|alert-no|5000::" + Date.now();
          }
        });
    },
    activeColor() {
      const primaryColor = this.primary;
      if (primaryColor) {
        const primaryRgb = this.hexToRgb(primaryColor);
        const pr = primaryRgb.r;
        const pg = primaryRgb.g;
        const pb = primaryRgb.b;
        document.documentElement.style.setProperty(
          "--primary-color",
          primaryColor
        );
        document.documentElement.style.setProperty("--primary-color-r", pr);
        document.documentElement.style.setProperty("--primary-color-g", pg);
        document.documentElement.style.setProperty("--primary-color-b", pb);
      }

      //secondary
      const secondaryColor = this.secondary;
      if (secondaryColor) {
        const secondaryRgb = this.hexToRgb(secondaryColor);
        const sr = secondaryRgb.r;
        const sg = secondaryRgb.g;
        const sb = secondaryRgb.b;
        document.documentElement.style.setProperty(
          "--secondary-color",
          secondaryColor
        );
        document.documentElement.style.setProperty("--secondary-color-r", sr);
        document.documentElement.style.setProperty("--secondary-color-g", sg);
        document.documentElement.style.setProperty("--secondary-color-b", sb);
      }
    },
    async setPrimaryColor() {
      this.primary_color = this.primary;
      this.saveColor();
      const actualColor = this.primary;
      const rgb = this.hexToRgb(this.primary);
      // Update separate RGB values
      const r = rgb.r;
      const g = rgb.g;
      const b = rgb.b;
      document.documentElement.style.setProperty(
        "--primary-color",
        actualColor
      );
      document.documentElement.style.setProperty("--primary-color-r", r);
      document.documentElement.style.setProperty("--primary-color-g", g);
      document.documentElement.style.setProperty("--primary-color-b", b);
    },
    async setSecondaryColor() {
      this.secondary_color = this.secondary;
      this.saveColor();
      const rgb = this.hexToRgb(this.secondary);
      // Update separate RGB values
      const r = rgb.r;
      const g = rgb.g;
      const b = rgb.b;
      document.documentElement.style.setProperty(
        "--secondary-color",
        this.secondary
      );
      document.documentElement.style.setProperty("--secondary-color-r", r);
      document.documentElement.style.setProperty("--secondary-color-g", g);
      document.documentElement.style.setProperty("--secondary-color-b", b);
    },
    removeProfilePicture() {
      this.uploadPending = true;
      //const formData = new FormData();
      //formData.append('image_url', null);
      getAPI
        .put(`accounts/users/${localStorage.user}/`, {
          image_url: null,
        })
        .then((payload) => {
          console.log(payload);
          this.userData.image_url = null;
          this.alertString =
            "Photo de profil supprimée avec succès|alert-yes|5000::" +
            Date.now();
          this.silentRefresh = Date.now();
          this.uploadPending = false;
        })
        .catch((err) => {
          this.alertString =
            "Échec de la suppression de la photo de profil|alert-no|5000::" +
            Date.now();
          this.uploadPending = false;
          console.log(err);
        });
    },

    async selectAvatar(avatarPath) {
      this.uploadPending = true;

      try {
        // Pour les images locales, on utilise fetch avec le chemin relatif
        const response = await fetch(avatarPath);
        if (!response.ok) {
          throw new Error(
            `Erreur lors du chargement de l'image: ${response.status}`
          );
        }

        const blob = await response.blob();

        // Créer un fichier à partir du blob
        const file = new File([blob], "avatar.png", { type: blob.type });

        // Créer FormData comme pour l'upload normal
        const formData = new FormData();
        formData.append("image_url", file);

        // Utiliser la même API que l'upload normal
        const payload = await getAPI.put(
          `accounts/users/upload-profile/${localStorage.user}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.userData.image_url = payload.data.data.image_url;
        this.alertString =
          "Avatar sélectionné avec succès|alert-yes|5000::" + Date.now();
        this.silentRefresh = Date.now();
        this.uploadPending = false;
      } catch (err) {
        this.alertString =
          "Échec de la sélection de l'avatar|alert-no|5000::" + Date.now();
        this.uploadPending = false;
        console.log(err);
      }
    },

    async setupTwoFA(method) {
      this.twoFAPending[method] = true;

      // Vérifier si la méthode est déjà active pour la désactiver
      const isCurrentlyActive =
        this.userData?.otp_methods?.includes(method) || false;

      try {
        if (isCurrentlyActive) {
          // Envoyer d'abord un code de vérification pour confirmer la désactivation
          await this.sendVerificationCode(0);

          this.twoFAMethod = method;
          this.disabledMethod = method;

          // Afficher le formulaire de vérification OTP
          this.show2FAVerificationForm = true;
          return;
        } else {
          // Envoyer la demande de vérification par email
          await this.sendVerificationCode(1);

          // Stocker la méthode choisie pour une utilisation ultérieure
          this.twoFAMethod = method;

          // Afficher le formulaire de vérification OTP
          this.show2FAVerificationForm = true;
        }
      } catch (error) {
        console.error("2FA setup error:", error);
        const errorMessage =
          error.response?.data?.message ||
          "Une erreur s'est produite lors de la configuration 2FA.";
        this.alertString = `${errorMessage}|alert-no|6000::` + Date.now();
      } finally {
        this.twoFAPending[method] = false;
      }
    },

    async verify2FACode() {
      const currentMethod = this.twoFAMethod;
      this.errors.verificationCode = null;

      if (!this.verificationCode || this.verificationCode.trim() === "") {
        this.errors.verificationCode =
          "Le code de vérification est obligatoire.";
        return;
      }

      try {
        const isDisabling = this.disabledMethod === this.twoFAMethod;

        // Configurer la méthode 2FA après vérification réussie
        const response = await getAPI.post("accounts/two-factor-config", {
          otp_method: this.twoFAMethod,
          action: isDisabling ? "remove" : "add",
          otp: this.verificationCode.trim(),
        });

        if (response.status === 200) {
          this.verificationCode = "";
          if (isDisabling) {
            // Rafraîchir les données et afficher le modal de désactivation
            this.retrieveUserData();
            this.show2FAVerificationForm = false;
            this.disabledMethod = currentMethod;
            this.showDisableSuccessModal = true;
          } else if (this.twoFAMethod === "app" && response.data.data) {
            this.otpCode = response.data.data.otp_secret;
            this.qrCodeData = response.data.data?.provisioning_uri;

            // Rafraîchir les données et afficher le QR code
            this.retrieveUserData();
            this.show2FAVerificationForm = false;
            this.showAppQRModal = true;
          } else if (this.twoFAMethod === "email") {
            // Rafraîchir les données et afficher le succès
            this.retrieveUserData();
            this.show2FAVerificationForm = false;
            this.showEmailSuccessModal = true;
          }

          // Réinitialiser les variables après le traitement
          if (isDisabling) {
            this.twoFAMethod = null;
          }
        }
      } catch (error) {
        console.error("2FA verification error:", error);
        const verificationError = error.response?.data?.message || "";
        const errorMessage = "As manager you need to have at last one opt method. Add app method before removing email."
        const errorAppMessage = "As manager you need to have at last one opt method. Add email method before removing app."
        const alertMessage = "Ajoutez au moins une methode d'authentification avant de supprimer la méthode de l'e-mail.";
        const alertAppMessage = "Ajoutez au moins une methode d'authentification avant de supprimer la méthode de l'application.";
        if(verificationError === errorMessage) {
          this.alertString = `${alertMessage}|alert-no|6000::` + Date.now();
          this.show2FAVerificationForm = false;
          this.twoFAMethod = null;
          this.disabledMethod = null;
          return;
        } else if(verificationError === errorAppMessage) {
          this.alertString = `${alertAppMessage}|alert-no|6000::` + Date.now();
          this.show2FAVerificationForm = false;
          this.twoFAMethod = null;
          this.disabledMethod = null;
          return;
        }
        this.errors.verificationCode =
          error.response?.data?.message || "Code de vérification invalide.";
      }
    },

    async sendVerificationCode(value) {
      try {
        if (value === 1) {
          // Send code for enabling 2FA
          await getAPI.post("accounts/two-factor-update-opt", {
            operation: value,
          });
        } else if (value === 0) {
          // Send code for disabling 2FA
          await getAPI.post("accounts/two-factor-update-opt", {
            operation: value,
          });
        } else {
          throw new Error("Invalid operation value");
        }
        this.alertString =
          "Un code de vérification a été envoyé à votre adresse email.|alert-yes|5000::" +
          Date.now();
      } catch (error) {
        console.error("Error sending code:", error);
        this.alertString =
          "Impossible d'envoyer le code de vérification. Veuillez réessayer plus tard.|alert-no|5000::" +
          Date.now();
      }
    },

    // Resend verification code
    async resendVerificationCode() {
      try {
        const operation = this.disabledMethod
          ? 0 // Pour désactivation
          : 1; // Pour activation
        await this.sendVerificationCode(operation);
      } catch (error) {
        console.error("Error resending code:", error);
      }
    },

    // Cancel verification
    cancelVerification() {
      this.show2FAVerificationForm = false;
      this.verificationCode = "";
      this.errors.verificationCode = null;
      this.twoFAMethod = null;
      this.disabledMethod = null;
    },
  },

  mounted() {
    this.retrieveUserData();
  },
};
</script>
<style scoped>
.cfa-block {
  background-color: #fff;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);
  -webkit-box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);
  -moz-box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);

  /* border: 1px solid transparent;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05); */
}

.form-group label {
  margin-bottom: 0.5em;
  font-weight: 400;
}

/* Language dropdown styles */
.language-dropdown-container {
  position: relative;
}

.language-dropdown {
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.language-dropdown:hover {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.cursor-pointer {
  cursor: pointer;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.language-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.language-option {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f8f9fa;
}

.language-option:last-child {
  border-bottom: none;
}

.language-option:hover {
  background-color: #f8f9fa;
}

.language-option.selected {
  background-color: #e3f2fd;
  color: #1976d2;
}

.hover-bg:hover {
  background-color: #f8f9fa;
}

/* Avatar dropdown styles */
.avatar-dropdown-menu {
  min-width: 300px;
  max-width: 400px;
}

.dropdown-header {
  padding: 0.5rem 1rem;
  font-weight: 600;
  color: #495057;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.avatar-grid-container {
  padding: 0.5rem;
}

.avatar-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}

.avatar-option {
  position: relative;
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.avatar-option:hover {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.avatar-option.selected {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.dropdown-divider {
  margin: 0.5rem 0;
  border-top: 1px solid #dee2e6;
}

.notification-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  background-color: #ff4d4d;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.3);
    opacity: 0.7;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* MFA Section Styles */
.mfa-section {
  height: 100%;
}

.mfa-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #132b4d;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}

.mfa-title i {
  color: #0bbbc4;
}

.mfa-description {
  color: #6c757d;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  flex: 1;
}

.mfa-action-btn {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  width: auto;
  min-width: 150px;
}

.mfa-btn-primary {
  background: #0bbbc4;
  color: #fff;
}

.mfa-btn-primary:hover:not(:disabled) {
  background: #09a4ac;
  box-shadow: 0 2px 8px rgba(11, 187, 196, 0.3);
  transform: translateY(-1px);
  color: #fff;
}

.mfa-btn-danger {
  background: #dc3545;
  color: #fff;
}

.mfa-btn-danger:hover:not(:disabled) {
  background: #c82333;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  transform: translateY(-1px);
  color: #fff;
}

.mfa-action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mfa-qr-section .alert {
  background: linear-gradient(
    135deg,
    rgba(11, 187, 196, 0.1) 0%,
    rgba(19, 43, 77, 0.05) 100%
  );
  border-left: 4px solid #0bbbc4;
}

.mfa-qr-section code {
  font-size: 1rem;
  color: #132b4d;
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .mfa-card {
    margin-bottom: 1rem;
  }

  .mfa-card-header h5 {
    font-size: 1rem;
  }
}

/* Modal Styles */
.mfa-modal-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #0bbbc4 0%, #09a4ac 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.mfa-modal-icon i {
  color: #fff;
}

.mfa-modal-icon.success {
  background: linear-gradient(135deg, #28a745 0%, #20963b 100%);
}

.mfa-modal-icon.warning {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
}
</style>
